export default __webpack_public_path__ + "static/media/Q5_0_resized.d65c4078.jpg";